import RequestAbstract from "../abstract";

export default class PublicTerminalShopWindows extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-terminal-shop-windows';
    }

}
